<template>
  <div :class="configureClass()">
    <small-loader v-if="downloadLoading"></small-loader>
    
    <div v-show="!downloadLoading" v-if="!otherClass" style="width:100%;height:150px;text-align: center;">
      <div style="width:100%;float:left;text-align:center;height:100px;padding-top:10px;">
        <div style="width:100%;float:left;text-align:center;padding-top:10px;">
          <CButton size="sm" @click="close()" color="danger">Close</CButton>
          <CButton size="sm" @click="downloadPdf" color="success" class="ml-2">Download PDF</CButton>
        </div>
        <div style="width:100%;float:left;text-align:center;padding-top:10px;" v-if="$store.state.user.user_type === 'csr'">
          <select class="form-control" v-model="order_group.csr_status" @change="changeCsrStatus()" style="width: 300px;margin-left:auto;margin-right:auto;">
            <option value="null">Select Folder</option>
              <!-- <option value="Components On Order">Components On Order</option> -->
              <option value="Good To Go">Good To Go</option>
              <option value="Sent To Art">Sent To Art</option>
              <!-- <option value="Sent To AWS for Color/Import">Sent To AWS for Color/Import</option> -->
              <option value="Sent To WE">Sent To WE</option>
              <option value="Hold/Sent For Approval">Hold/Sent For Approval</option>
              <option value="Events-Check Shipping">Events-Check Shipping</option>
          </select>
        </div>
      </div>
      <div style="width:100%;float:left;color: red;height: 50px;font-size: 14px;text-decoration: underline;text-align:center;" v-if="!allowEdit">
        This is the original PDF, edits that are made to this will NOT be saved on the server, but the edit will be downloaded for personal use.
      </div>
    </div>
    <div v-show="!downloadLoading && !notExist" id="adobe-dc-view"></div>
    <div style="width:100%;height:calc(100% - 150px);text-align:center;background-color:#fff;" v-if="notExist">
      There is no PDF on the server for this log number. Please contact acoleman@paifashion.com if you think there should be.
    </div>
  </div>
</template>
<script>
var methods = {}

methods.close = function () {
  this.$emit('closed')
}

methods.configureClass = function () {
  if (!this.otherClass) {
    return 'pdfWrapper'
  } else {
    return this.otherClass
  }
}

methods.changeCsrStatus = function () {
  const postData = {
    form: this.order_group
  }
  axios.post(this.$apiAdress + '/api/orders/changeCsrStatus?token=' + localStorage.getItem('api_token'), postData).then(response => {
    console.log(response)
  })
}

methods.getPdf = function () {
  console.log('begin GET PDF funciton. just before decalring cc_number variable...')
  // choose the best identifier you have
  const cc = this.order_group?.cc_number ?? null;

  const postData = { type: this.pdf_type };
  if (this.order_group?.order_group_id) postData.order_group_id = this.order_group.order_group_id;
  if (cc) postData.cc_number = cc;
  console.log(postData)
  axios.post(this.$apiAdress + '/api/orders/downloadPdf?token=' + localStorage.getItem('api_token'), postData).then(response => {
    this.downloadLoading = false
    console.log('get PDF response:: ----- ::', response)
    // const blob = new Blob([response.data], { type: 'application/pdf' })
    const url = window.URL.createObjectURL(new Blob([response.data]))
    // console.log(blob)
    if (response.data !== 'not-exist') {
      this.downloadLoading = false
      this.pdfData = response.data
      this.tryLoad(response.data)
    } else {
      this.notExist = true
    }
  })
}

methods.downloadPdf = function () {

    if (!this.pdfData) return

    const bytes = this.base64ToArrayBuffer(this.pdfData)

    const blob = new Blob([bytes], {
        type: 'application/pdf'
    })

    const url = URL.createObjectURL(blob)

    const a = document.createElement('a')
    a.href = url
    a.download = this.order_group.as400_log_number + '.pdf'
    a.click()

    URL.revokeObjectURL(url)
}

methods.tryLoad = function (pdfData) {
  const clientID = process.env.VUE_APP_ADOBE_ID;

  if (!this.repView) {
    var viewOptions = {
      embedMode: "FULL_WINDOW",
      defaultViewMode: "FIT_WIDTH",
      // showCommentsPanel: false
      // enableAnnotationAPIs: true
      showAnnotationTools: true,
      // showPrintPDF: false
    };
  } else {
    var viewOptions = {
      embedMode: "FULL_WINDOW",
      defaultViewMode: "FIT_WIDTH",
      // showCommentsPanel: false
      // enableAnnotationAPIs: true
      showAnnotationTools: false,
      // showPrintPDF: false
    };
  }

  var that = this

 //  var adobeDCView = new AdobeDC.View({clientId: "<YOUR_CLIENT_ID>", divId: "adobe-dc-view"});
 //  adobeDCView.previewFile(
 // {
 //    content:   {location: {url: "https://documentservices.adobe.com/view-sdk-demo/PDFs/Bodea Brochure.pdf"}},
 //    metaData: {fileName: "Bodea Brochure.pdf"}
 // });
  
  var adobeDCView = new AdobeDC.View({
    clientId: clientID,
    divId: "adobe-dc-view"
  });
  var previewFilePromise = adobeDCView.previewFile(
    {
      // convert the Base64 encoded PDF and convert it to an ArrayBuffer
      // and pass it as a Promise
      content: { promise: Promise.resolve(this.base64ToArrayBuffer(pdfData)) },
      // The filename name to display in the View SDK UI
      // and also used as the filename of the PDF when downloaded
      metaData: { fileName: that.order_group.as400_log_number + '.pdf' }
    },
    viewOptions,
  );

  previewFilePromise.then(adobeViewer => {
    adobeViewer.executeCommand('TOGGLE_COMMENTING', true);
  })

  if (that.allowEdit) {
    adobeDCView.registerCallback(
      AdobeDC.View.Enum.CallbackType.SAVE_API,
      function (metaData, content, options) {
        console.log('oooo yay saved')
          var uint8Array = new Uint8Array(content);
          var blob = new Blob([uint8Array], { type: 'application/pdf' });
          var formData = new FormData();
          console.log(blob)
          // var pdfFilename = urlToPDF.split("/").slice(-1)[0];
          // pdfFilename = pdfFilename.split(".")[0] + "-" + uuidv4() + ".pdf";
          formData.append('file', blob);
          formData.append('order', JSON.stringify(that.order_group))

          // var zipFileName = pdfFilename.replace(".pdf", ".zip");

            axios.post(that.$apiAdress + '/api/orders/updateGroupPdf?token=' + localStorage.getItem('api_token'),
            formData,
            { headers: {
                'Content-Type': 'multipart/form-data'
            }}
            ).then(response => {
              console.log(response)
            })

            return new Promise((resolve, reject) => {
                resolve({
                    code: AdobeDC.View.Enum.ApiResponseCode.SUCCESS,
                    data: {
                        // metaData: { fileName: urlToPDF.split("/").slice(-1)[0] }
                    }
                });
            });

      }
    );
  }

}

methods.base64ToArrayBuffer = function (base64) {
  var bin = window.atob(base64);
  var len = bin.length;
  var uInt8Array = new Uint8Array(len);
  for (var i = 0; i < len; i++) {
    uInt8Array[i] = bin.charCodeAt(i);
  }
  return uInt8Array.buffer;
}

export default {
  // ===Component name
  name: "AdobePdfViewer",
  // ===Props passed to component
  props: ['order_group', 'pdf_type', 'allowEdit', 'otherClass', 'repView', 'from',],
  // ===Components used by this component
  components: {

  },
  // ====component Data properties
  data(){
      return{
        notExist: false,
        downloadLoading: true,
        pdfData: null
      }
  },
  // ===Code to be executed when Component is mounted
  mounted() {
    if (!document.getElementById('adobeScript')) {
      let adobe = document.createElement('script')
      adobe.setAttribute('id', 'adobeScript')
      adobe.setAttribute('src', 'https://documentservices.adobe.com/view-sdk/viewer.js')
      document.head.appendChild(adobe)
      console.log('loaded adobe')
    }

      this.getPdf()
  },
  // ===Computed properties for the component
  computed: {},
  // ===Component methods
  methods: methods
}
</script>
<!-- styles -->
<!-- adding scoped attribute will apply the css to this component only -->
<style scoped lang="scss">
  .pdfWrapper {
    width: 100%;
    height: 100%;
    position:fixed;
    top:0;
    left:0;
    right:0;
    bottom:0;
    background-color: rgba(0,0,0,1);
    z-index:10000;

    #adobe-dc-view {
      width:100%;height:calc(100% - 100px);
    }
  }

  .in_pdf_order {
    width:100%;
    position:relative;
    float:left;
    height:700px;

    #adobe-dc-view {
      width:100%;height:100%;
    }
  }
</style>
